import React, { useEffect, useState } from "react";
import {
  Accordion,
  ActivateCreditCard,
  BackToBenefitsButton,
  MainImageBackground,
  Separator,
  TaxRefund,
} from "src/components";

import styles from "./styles.module.scss";
import UpdateContactDetails from "src/components/updateContactDetails";
import { UICard, UIText } from "src/components/uIKit";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { images } from "src/assets/images/images";
import { useLocation } from "react-router-dom";
import { ROUTES, STATE, TEXT_TAGS, URL_SOURCE_TYPE } from "src/utils/enums";
import { getChannelId, logPfsAnalyticsEvent } from "src/utils/utils";
import {
  getCCInfo,
  getPersonalDetails,
} from "src/redux/slices/userSlice/UserApi";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";
import { UpdateOnboardingAnalytics } from "src/utils/types";
import { useRouteParams } from "src/hooks/useRouteParams";

const BenefitsScreen: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const [refreshHeight, setRefreshHeight] = useState(false);
  const { currentSource } = useRouteParams();
  const {
    strings,
    firstSectionValid,
    secondSectionValid,
    hostUrl,
    travelPolicyNumber,
    personalId,
    businessUnit,
    currentState,
  } = useAppSelector((state) => state.app);
  const lowerCaseCurrentSource = currentSource.toLowerCase();
  const isSmsOrCampaignOrMarketingOrSmsShareOrApp =
    lowerCaseCurrentSource === URL_SOURCE_TYPE.SMS ||
    lowerCaseCurrentSource === URL_SOURCE_TYPE.CAMPAIGN ||
    lowerCaseCurrentSource === URL_SOURCE_TYPE.MARKETING ||
    lowerCaseCurrentSource === URL_SOURCE_TYPE.SMS_SHARE ||
    lowerCaseCurrentSource === URL_SOURCE_TYPE.APP;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      switch (currentState) {
        case STATE.UPDATE_CONTACT_DETAILS:
          logPfsAnalyticsEvent({
            update_contact_details: true,
          } as UpdateOnboardingAnalytics);
          // useLogAnalytics({ update_contact_details: true });
          break;
        case STATE.ACTIVATE_CREDIT_CARD:
          logPfsAnalyticsEvent({
            activate_credit_card: true,
          } as UpdateOnboardingAnalytics);
          break;
      }
    }, 300); // 300ms delay

    return () => {
      clearTimeout(timeoutId); // Cleanup timeout on state change or unmount
    };
  }, [currentState]);

  const onRefreshHeight = () => {
    setRefreshHeight(!refreshHeight);
  };
  useEffect(() => {
    const data = {
      feCustTravelPolicyNumber: travelPolicyNumber,
      feCustPersonalId: personalId,
      feBU: businessUnit,
    };
    const personalRequestData = { ...data, feChannel: getChannelId(hostUrl) };

    dispatch(getCCInfo(data));
    dispatch(getPersonalDetails(personalRequestData));
  }, []);
  const getAccordionIndex = () => {
    const hostTempUrl = hostUrl ? "/" + hostUrl + "/" : "";

    if (location.pathname === hostTempUrl + ROUTES.UPDATE_CONTACT_DETAILS) {
      return STATE.UPDATE_CONTACT_DETAILS;
    } else if (
      location.pathname ===
      hostTempUrl + ROUTES.ACTIVATE_CREDIT_CARD
    ) {
      return STATE.ACTIVATE_CREDIT_CARD;
    } else if (location.pathname === hostTempUrl + ROUTES.TAX_REFAUND) {
      return STATE.TAX_REFAUND;
    }
    return -1;
  };

  return (
    <div className={styles.container}>
      <MainImageBackground
        desktopImageSrc={images.mainImage}
        mobileImageSrc={images.mainMobile}
      />
      <UICard>
        <>
          {
            !isSmsOrCampaignOrMarketingOrSmsShareOrApp && <BackToBenefitsButton style={styles.backToBenefitsMobile} />
          }
          <ScreenReaderText
            text={strings.acc_t_benefits_title}
            announnceDelay={2100}
          />

          <UIText
            text={strings.t_benefits_title}
            tag={TEXT_TAGS.H1}
            size={24}
            weight={500}
            style={styles.cardTitle}
            ariaLabel={strings.acc_t_benefits_title}
          />
          <br />
          <Separator className={styles.separator} />

          <Accordion
            index={STATE.UPDATE_CONTACT_DETAILS}
            title={strings.t_benefits_update_contact_info}
            isDone={firstSectionValid}
            isOpen={getAccordionIndex() === STATE.UPDATE_CONTACT_DETAILS}
            route={ROUTES.UPDATE_CONTACT_DETAILS}
            accordionIcon={images.left}
          >
            <UpdateContactDetails />
          </Accordion>

          <Accordion
            refreshHeight={refreshHeight}
            index={STATE.ACTIVATE_CREDIT_CARD}
            title={strings.t_benefits_enable_card}
            isDone={secondSectionValid}
            isOpen={getAccordionIndex() === STATE.ACTIVATE_CREDIT_CARD}
            route={ROUTES.ACTIVATE_CREDIT_CARD}
            accordionIcon={images.left}
          >
            <ActivateCreditCard onRefreshHeight={onRefreshHeight} />
          </Accordion>
        </>
      </UICard>
    </div>
  );
};

export default BenefitsScreen;
